import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";
import { IShow } from "@eagerdog/interfaces";
import { buildCwagsFeoRow } from "./cwagsFeo";

/**
 * C-WAGS Games registration form.
 *
 * One multi-select row per game (element); the options are the levels the show
 * actually offers for that game. Teams may enter any level or combination of
 * levels at one trial, so nothing is gated on titles. Pairs and Team also
 * collect a partner (see FormBuilder — rendered under the row, stored in
 * dog_class.extra).
 */
export namespace CWagsGames {
  const GAME_ELEMENTS: string[] = [
    Constants.dog_class_element.cwags_games_colors,
    Constants.dog_class_element.cwags_games_black_jack,
    Constants.dog_class_element.cwags_games_pairs,
    Constants.dog_class_element.cwags_games_team,
    Constants.dog_class_element.cwags_games_grab_bag,
  ];

  const ALL_LEVELS: string[] = [
    Constants.dog_class_element_level.cwags_games_level_1,
    Constants.dog_class_element_level.cwags_games_level_2,
    Constants.dog_class_element_level.cwags_games_level_3,
    Constants.dog_class_element_level.cwags_games_level_4,
    Constants.dog_class_element_level.cwags_games_zoom_1,
    Constants.dog_class_element_level.cwags_games_zoom_1_5,
    Constants.dog_class_element_level.cwags_games_zoom_2,
  ];

  export const getForm = (show?: IShow): IEventRegisterRow[] => {
    const offeredLevels = (element: string): string[] => {
      // No show context (static form): expose everything
      if (!show?.show_elements || show.show_elements.length === 0) {
        return ALL_LEVELS;
      }

      const matching = show.show_elements.filter((se) => se.show_element === element);
      if (matching.length === 0) {
        return [];
      }

      const selected = new Set(matching.map((se) => se.level));
      return ALL_LEVELS.filter((level) => selected.has(level));
    };

    const rows: IEventRegisterRow[] = [];

    for (const element of GAME_ELEMENTS) {
      const levels = offeredLevels(element);
      if (levels.length === 0) {
        continue;
      }

      const options = levels.map((level) => ({ value: level, id: level }));

      rows.push({
        inputs: [{
          type: "checkbox",
          multiSelect: true,
          label: element,
          options,
        }],
      });

      // FEO row directly under the regular row when the show offers FEO
      const feoRow = buildCwagsFeoRow(show, element, options);
      if (feoRow) {
        rows.push(feoRow);
      }
    }

    return rows;
  };

  export const form: IEventRegisterRow[] = getForm();
}
